<template>
    <b-container>
        <h2 class="mt-4">Get digging!</h2>
        <h5 style="color: rgba(235, 63, 36,100);">You have chosen {{$store.state.selectedTracks.length}} of your 3 tracks.</h5>
        <h5>Search results - Tap a Choon to choose</h5>
        <track-selector :tracks="tracks"></track-selector>
    </b-container>
</template>

<script>
    import TrackSelector from '@/components/tracks/TrackSelector.vue';
    import { EventBus } from "../../EventBus";

    export default {
        name: "SearchView",
        components: {
            TrackSelector
        },
        data() {
            return {
                tracks: []
            }
        },
        props: {
            q: String
        },
        mounted() {
            if (this.q) {
                EventBus.$emit('loading-show');
                this.$axios.get(`tracks/${this.q}`).then(result => {
                    EventBus.$emit('loading-hide');
                    this.tracks = result.data;
                }).catch(() => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: 'Oops this isn’t working, don’t worry please show your host to resolve it', type: 'danger'});
                });
            }
        }
    }
</script>

<style scoped>

</style>
